<template>
  <div class="sidebar" :class="{ 'is-collapse': isCollapse }">
    <div class="logo">
      <img
        src="@/assets/images/ui/logo.png"
        alt="Zoetis"
        class="logo-img"
        v-if="!isCollapse"
      />
      <img
        src="@/assets/images/ui/logo.png"
        alt="Zoetis"
        class="logo-img small"
        v-else
      />
    </div>

    <el-menu
      :default-active="activeMenu"
      :collapse="isCollapse"
      @select="handleSelect"
    >
      <!-- 首页 -->
      <el-menu-item index="/" :class="getMenuItemClass('/')">
        <el-icon>
          <img
            src="@/assets/images/ui/homeon.png"
            v-if="activeMenu === '/'"
            class="menu-icon"
          />
          <img src="@/assets/images/ui/homeoff.png" v-else class="menu-icon" />
        </el-icon>
        <span>首页</span>
      </el-menu-item>

      <!-- 基础数据管理 -->
      <el-sub-menu index="basic-data">
        <template #title>
          <el-icon>
            <img
              src="@/assets/images/ui/dataon.png"
              v-if="activeMenu.startsWith('/basic-data')"
              class="menu-icon"
            />
            <img
              src="@/assets/images/ui/dataoff.png"
              v-else
              class="menu-icon"
            />
          </el-icon>
          <span>基础数据管理</span>
        </template>

        <!-- 遍历一级菜单 -->
        <template v-for="item in basicDataMenus" :key="item.path">
          <!-- 有子菜单的情况 -->
          <el-sub-menu
            v-if="item.children && item.children.length"
            :index="item.path"
          >
            <template #title>
              <div :style="`font-size: ${sidebarConfig.secondaryMenuFontSize}`">
                {{ item.title }}
              </div>
            </template>
            <el-menu-item
              v-for="child in item.children"
              :key="child.path"
              :index="child.path"
              :class="getMenuItemClass(child.path)"
            >
              {{ child.title }}
            </el-menu-item>
          </el-sub-menu>

          <!-- 没有子菜单的情况 -->
          <el-menu-item
            v-else
            :index="item.path"
            :class="getMenuItemClass(item.path)"
          >
            {{ item.title }}
          </el-menu-item>
        </template>
      </el-sub-menu>

      <!-- 计算结果 -->
      <el-sub-menu index="calculation-result">
        <template #title>
          <el-icon>
            <img
              src="@/assets/images/ui/calcon.png"
              v-if="activeMenu.startsWith('/calculation')"
              class="menu-icon"
            />
            <img
              src="@/assets/images/ui/calcoff.png"
              v-else
              class="menu-icon"
            />
          </el-icon>
          <span>计算结果</span>
        </template>
        <!-- 遍历一级菜单 -->
        <template v-for="item in calculationMenus" :key="item.path">
          <!-- 有子菜单的情况 -->
          <el-sub-menu
            v-if="item.children && item.children.length"
            :index="item.path"
          >
            <template #title>
              <div :style="`font-size: ${sidebarConfig.secondaryMenuFontSize}`">
                {{ item.title }}
              </div>
            </template>
            <el-menu-item
              v-for="child in item.children"
              :key="child.path"
              :index="child.path"
              :class="getMenuItemClass(child.path)"
            >
              {{ child.title }}
            </el-menu-item>
          </el-sub-menu>

          <!-- 没有子菜单的情况 -->
          <el-menu-item
            v-else
            :index="item.path"
            :class="getMenuItemClass(item.path)"
          >
            {{ item.title }}
          </el-menu-item>
        </template>
      </el-sub-menu>

      <!-- 用户管理 -->
      <el-menu-item
        index="/user-management"
        :class="getMenuItemClass('/user-management')"
      >
        <el-icon>
          <img
            src="@/assets/images/ui/useron.png"
            v-if="activeMenu === '/user-management'"
            class="menu-icon"
          />
          <img src="@/assets/images/ui/useroff.png" v-else class="menu-icon" />
        </el-icon>
        <span>用户管理</span>
      </el-menu-item>

      <!-- 历史版本 -->
      <el-menu-item
        index="/history-version"
        :class="getMenuItemClass('/history-version')"
      >
        <el-icon>
          <img
            src="@/assets/images/ui/historyon.png"
            v-if="activeMenu === '/history-version'"
            class="menu-icon"
          />
          <img
            src="@/assets/images/ui/historyoff.png"
            v-else
            class="menu-icon"
          />
        </el-icon>
        <span>历史版本</span>
      </el-menu-item>

      <!-- 数据导出记录 -->
      <el-menu-item
        index="/export-records"
        :class="getMenuItemClass('/export-records')"
      >
        <el-icon>
          <img
            src="@/assets/images/ui/exporton.png"
            v-if="activeMenu === '/export-records'"
            class="menu-icon"
          />
          <img
            src="@/assets/images/ui/exportoff.png"
            v-else
            class="menu-icon"
          />
        </el-icon>
        <span>数据导出记录</span>
      </el-menu-item>

      <!-- 对话框示例 -->
      <!-- <el-menu-item 
        index="/dialog-demo" 
        :class="getMenuItemClass('/dialog-demo')"
      >
        <template #title>
          <div class="menu-icon-container">
            <img src="@/assets/images/ui/exporton.png" v-if="activeMenu === '/dialog-demo'" class="menu-icon" />
            <img src="@/assets/images/ui/exportoff.png" v-else class="menu-icon" />
          </div>
          <span>对话框示例</span>
        </template>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

// 侧边栏配置
const sidebarConfig = {
  expandedWidth: "200px", // 展开时的宽度
  collapsedWidth: "64px", // 折叠时的宽度
  primaryMenuFontSize: "16px", // 一级菜单字体大小
  secondaryMenuFontSize: "14px", // 二级和三级菜单字体大小
};

const props = defineProps<{
  isCollapse: boolean;
}>();

const route = useRoute();
const router = useRouter();

const activeMenu = computed(() => route.path);

// 路由检查逻辑
const hasRoute = (path: string) => {
  try {
    // 首页特殊处理
    if (path === "/") return true;

    // 检查路由是否存在
    router.resolve(path);
    return true;
  } catch (e) {
    return false;
  }
};

// 菜单项样式类
const getMenuItemClass = (path: string) => ({
  "has-page": hasRoute(path),
});

// 基础数据管理菜单
const basicDataMenus = [
  {
    path: "/basic-data/flow-data",
    title: "流向数据",
    children: [
      { path: "/basic-data/flow-data/with-code", title: "数据明细" },
      // { path: '/basic-data/flow-data/without-code', title: '流向数据-无码' },
      { path: "/basic-data/flow-data/sales-mark", title: "销量标记" },
    ],
  },
  {
    path: "/basic-data/prod-group",
    title: "产品组",
    children: [
      { path: "/basic-data/prod-group/group-list", title: "产品组" },
      { path: "/basic-data/prod-group/group-detail", title: "产品组详情" },
    ],
  },
  { path: "/basic-data/store-data", title: "门店主数据" },
  { path: "/basic-data/dealer-data", title: "经销商主数据" },
  { path: "/basic-data/customer-return", title: "经销商特批返还" },
  { path: "/basic-data/whitelist", title: "白名单" },
  { path: "/basic-data/blacklist", title: "黑名单" },
  { path: "/basic-data/box-punishment-rules", title: "窜货盒数处罚规则" },
  { path: "/basic-data/store-punishment-rules", title: "窜货家数处罚规则" },
  { path: "/basic-data/product-rules", title: "产品转换规则" },
];

// 计算结果菜单
const calculationMenus = [
  {
    path: "/calculation/monthly",
    title: "月度结果",
    children: [
      { path: "/calculation/product-quantity-month", title: "按盒数汇总" },
      { path: "/calculation/product-store-month", title: "产品店铺数" },
      { path: "/calculation/avg-store-month", title: "按店铺数汇总" },
      { path: "/calculation/monthDetail", title: "月度明细" },
    ],
  },
  {
    path: "/calculation/quarterly",
    title: "季度结果",
    children: [
      { path: "/calculation/product-quantity-quarter", title: "按盒数汇总" },
      { path: "/calculation/product-store-quarter", title: "产品店铺数" },
      { path: "/calculation/avg-store-quarter", title: "按店铺数汇总" },
      { path: "/calculation/punishment-total", title: "处罚报告季度汇总" },
      { path: "/calculation/punishment-details", title: "处罚数据" },
    ],
  },
];

const handleSelect = (index: string) => {
  router.push(index);
};
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "@/styles/variables.scss" as vars;

.sidebar {
  width: v-bind("sidebarConfig.expandedWidth");
  height: 100vh;
  background-color: #ffffff;
  transition: width 0.3s;
  display: flex;
  flex-direction: column;

  &.is-collapse {
    width: v-bind("sidebarConfig.collapsedWidth");

    .logo-text {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }

  .logo {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    background-color: white;
    flex-shrink: 0;

    .logo-text {
      font-size: 16px;
      font-weight: bold;
      color: vars.$primary-color;
      white-space: nowrap;
    }

    .logo-img {
      height: 36px;
      object-fit: contain;

      &.small {
        height: 36px;
        max-width: 100%;
      }
    }
  }

  .menu-icon-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .menu-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  :deep(.el-icon) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  :deep(.el-menu) {
    flex: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  .collapse-btn {
    position: absolute;
    right: -15px;
    top: 50px;
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }
  }

  :deep(.has-page) {
    position: relative;

    /* 注释掉橙色小点标记
    &::before {
      content: '';
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: green;
    }
    */
  }

  //&.is-collapse {
  //:deep(.has-page) {
  /* 注释掉橙色小点标记
      &::before {
        left: 4px;
      }
      */
  //}
  //}

  :deep(.el-menu-item.is-active) {
    color: vars.$primary-color !important;
    background-color: color.mix(#ffffff, vars.$primary-color, 90%) !important;
  }

  :deep(.el-menu-item:hover) {
    color: vars.$primary-color !important;
  }

  // 修改展开收缩箭头颜色为主色调
  :deep(.el-sub-menu) {
    .el-sub-menu__icon-arrow {
      color: vars.$primary-color;
      font-weight: bold;
      font-size: 14px;
      transform: scale(1.2);
      position: absolute;
      right: 0;
      margin-top: 0;
      top: 30%;
      transform: translateY(-50%);
    }

    .el-sub-menu__title {
      display: flex;
      align-items: center;
    }
  }

  // 修改展开收缩箭头在hover状态下的颜色
  :deep(.el-sub-menu:hover) {
    .el-sub-menu__icon-arrow {
      color: vars.$primary-color;
      font-weight: bold;
    }
  }

  // 修改展开收缩箭头在激活状态下的颜色
  :deep(.el-sub-menu.is-active) {
    .el-sub-menu__icon-arrow {
      color: vars.$primary-color;
      font-weight: bold;
    }
  }

  // 设置一级菜单字体大小
  :deep(.el-menu > .el-sub-menu > .el-sub-menu__title),
  :deep(.el-menu > .el-menu-item) {
    font-size: v-bind("sidebarConfig.primaryMenuFontSize");
  }

  // 设置二级和三级菜单字体大小
  :deep(.el-menu--inline .el-menu-item) {
    font-size: v-bind("sidebarConfig.secondaryMenuFontSize");
  }

  // 特别针对"流向数据"这样的二级菜单标题
  :deep(.el-sub-menu .el-sub-menu .el-sub-menu__title) {
    font-size: v-bind("sidebarConfig.secondaryMenuFontSize") !important;
  }

  // 确保自定义的二级菜单标题类也应用正确的字体大小
  :deep(.el-sub-menu__title--second-level) {
    font-size: v-bind("sidebarConfig.secondaryMenuFontSize") !important;
  }

  :deep(.el-menu-item) {
    display: flex;
    align-items: center;
  }

  // 确保二级菜单标题的内容也使用正确的字体大小
  :deep(.el-sub-menu .el-sub-menu__title span),
  :deep(.el-sub-menu .el-sub-menu__title div) {
    font-size: inherit;
  }
}
</style>